import { CLEAR_ALL_THUMBNAILS } from '../actions';

export default () => {
  return store => next => action => {
    // eslint-disable-next-line default-case
    switch (action.type) {
      case CLEAR_ALL_THUMBNAILS: {
        const thumbnails = store.getState().thumbnails;
        if (thumbnails) {
          Object.keys(thumbnails).forEach((thumbnailKey) => {
            URL.revokeObjectURL(thumbnails[thumbnailKey].attachmentUrl);
          });
        }

        break;
      }
    }
    return next(action);
  };
};
